export const USER_LOGIN_PATH = "api/v1/user/login";
export const ADMIN_LOGIN_PATH = "api/v1/user/login-admin";

const LOGIN_PATHS = [USER_LOGIN_PATH, ADMIN_LOGIN_PATH];

// Login failures are the user's problem to fix, not a sign of an expired
// session, so the interceptor must never log the user out because of them.
export const isLoginRequestUrl = (url?: string | null): boolean => {
  if (!url) return false;
  return LOGIN_PATHS.some((path) => url.includes(path));
};
